import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFirestore } from 'angularfire2/firestore';
@Pipe({
  name: 'obtenerPropiedadConfirmacionServicios'
})
export class ObtenerPropiedadDeConfrimacionesServicio implements PipeTransform {
    constructor(public afs: AngularFirestore) { }
  transform(arregloServicios:any): any {
    for (const key in arregloServicios) {
        if (arregloServicios.hasOwnProperty(key)) {            
            return arregloServicios[key];
            
        }
    }
    
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/propiedad-confirmaciones-servicios.pipe.ts